<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$t('StationManagement.StationName')" :label-width="100">
				<Input type="text" v-model="formInline.StationName" :placeholder="$t('StationManagement.StationName')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('addStation')" v-if="hasWidgets('add')">{{ $t('StationManagement.AddStation') }}</Button>
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getStationInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal :mask-closable="false" @on-cancel="cancelPictures" v-model="modalView" :title="modal.Title" width="60%">
			
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='addStation'||modal.type=='updateStation'||modal.type=='viewStation'" ref="StationForm"
				:model="StationForm" :label-width="150">
				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.StationCode')" prop="StationCode" v-show="false">
						<Input :disabled="ifup" v-model="StationForm.StationCode" :placeholder="$t('StationManagement.StationCode')"></Input>
					</FormItem>
					<FormItem :label="$t('StationManagement.StationName')" prop="StationName">
						<Input :disabled="ifViewStation" v-model="StationForm.StationName" :placeholder="$t('StationManagement.StationName')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.OperatorId')" prop="OperatorId" v-show="false">
						<Input :disabled="ifAddStation" v-model="StationForm.OperatorId" :placeholder="$t('StationManagement.OperatorId')"></Input>
					</FormItem>
					<FormItem :label="$t('StationManagement.OperatorName')" prop="OperatorName">
						
						<Select :disabled="ifViewStation" @on-change="OperatorNameChange" :placeholder="$t('StationManagement.OperatorName')"
							v-model="StationForm.OperatorName">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatortypeList" :value="item.Name">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.StationPicture')" prop="StationCode">
						<div class="demo-upload-list" :key="item.uid" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" :disabled="ifViewStation" :headers="upHeader" :show-upload-list="false"
							:default-file-list="defaultList" :on-success="handleSuccess" name="UpFile" :format="['jpg','jpeg','png']"
							:max-size="2048" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
							:before-upload="handleBeforeUpload" multiple type="drag" :action="uploadImageUrl"
							style="display: inline-block;width:58px;">
							<div style="width: 58px;height:58px;line-height: 58px;">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
						<Modal title="View Image" v-model="visible">
							<img :src="imgName" v-if="visible" style="width: 100%">
						</Modal>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ServiceTel')" prop="ServiceTel">
						<Input :disabled="ifViewStation" v-model="StationForm.ServiceTel" :placeholder="$t('StationManagement.ServiceTel')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.StationTel')" prop="StationTel">
						<Input :disabled="ifViewStation" v-model="StationForm.StationTel" :placeholder="$t('StationManagement.StationTel')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.BusinessHours')" prop="BusinessHours">
						<Input :disabled="ifViewStation" v-model="StationForm.BusinessHours" :placeholder="$t('StationManagement.BusinessHours')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" style="margin-bottom: 10px;">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.StationType')" prop="StationType">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.StationType')" v-model="StationForm.StationType">
							<Option :value="1">{{ 1 | StationTypeDesc }}</Option>
							<Option :value="50">{{ 2 | StationTypeDesc }}</Option>
							<Option :value="100">{{ 100 | StationTypeDesc }}</Option>
							<Option :value="101">{{ 101 | StationTypeDesc }}</Option>
							<Option :value="102">{{ 102 | StationTypeDesc }}</Option>
							<Option :value="103">{{ 103 | StationTypeDesc }}</Option>
							<Option :value="255">{{ 255 | StationTypeDesc }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.StationProperty')" prop="StationProperty">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.StationProperty')" v-model="StationForm.StationProperty">
							<Option :value="1">{{ 1 | StationPropertyDesc }}</Option>
							<Option :value="2">{{ 2 | StationPropertyDesc }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8" v-if="false">
					<FormItem :label="$t('StationManagement.ParkingDeduction')" prop="ParkingDeduction">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.ParkingDeduction')" v-model="StationForm.ParkingDeduction">
							<Option :value="0">{{ $t('StationManagement.Unconfigured') }}</Option>
							<Option v-bind:key="item.Id" v-for="(item) in StationParkingList" :value="item.Id">{{item.Name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ChargeFronter')" prop="ChargeFronter">
						<Select :disabled="ifup || ifViewStation" :placeholder="$t('StationManagement.ChargeFronter')" v-model="StationForm.ChargeFronter">
							<Option v-bind:key="item.Id" v-for="(item) in ChargeFronterList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8" v-if="false">
					<FormItem :label="$t('StationManagement.ParkingLockFronter')" prop="ParkingLockFronter">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.ParkingLockFronter')" v-model="StationForm.ParkingLockFronter">
							<Option :value="0">{{ $t('StationManagement.Unconfigured') }}</Option>
							<Option v-bind:key="item.Id" v-for="(item) in ChargeFronterList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.AreaCode')" prop="AreaCode">
						<Input :disabled="ifViewStation" v-model="StationForm.AreaCode" :placeholder="$t('StationManagement.AreaCode')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.AddrDetail')" prop="Address">
						<Input :disabled="ifViewStation" v-model="StationForm.Address" :placeholder="$t('StationManagement.AddrDetail')"></Input>
					</FormItem>
					</Col>
					<Col :span="8" v-if="false">
					<FormItem :label="$t('StationManagement.SiteGuide')" prop="SiteGuide">
						<Input :disabled="ifViewStation" v-model="StationForm.SiteGuide" :placeholder="$t('StationManagement.SiteGuide')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.Longitude')" prop="Longitude">
						<Input :disabled="ifViewStation" v-model.number="StationForm.Longitude" :placeholder="$t('StationManagement.Longitude')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.Latitude')" prop="Latitude">
						<Input :disabled="ifViewStation" v-model.number="StationForm.Latitude" :placeholder="$t('StationManagement.Latitude')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label-width="0">
						<Button :disabled="ifViewStation" type="warning" size="small" @click="mapOpen">{{ $t('StationManagement.mapOpen') }}</Button>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ElectricityFee')" prop="ElectricityFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ElectricityFee" :placeholder="$t('StationManagement.ElectricityFee')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ServiceFee')" prop="ServiceFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ServiceFee" :placeholder="$t('StationManagement.ServiceFee')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkFee')" prop="ParkFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkFee" :placeholder="$t('StationManagement.ParkFee')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.MatchCar')" prop="MatchCar">
						<Input :disabled="ifViewStation" v-model="StationForm.MatchCar" :placeholder="$t('StationManagement.MatchCar')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkInfo')" prop="ParkInfo">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkInfo" :placeholder="$t('StationManagement.ParkInfo')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkNum')" prop="ParkNum">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkNum" :placeholder="$t('StationManagement.ParkNum')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.Construction')" prop="Construction">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.Construction')" v-model="StationForm.Construction">
							<Option :value="1">{{ 1 | ConstructionTypeDesc }}</Option>
							<Option :value="2">{{ 2 | ConstructionTypeDesc }}</Option>
							<Option :value="3">{{ 3 | ConstructionTypeDesc }}</Option>
							<Option :value="4">{{ 4 | ConstructionTypeDesc }}</Option>
							<Option :value="5">{{ 5 | ConstructionTypeDesc }}</Option>
							<Option :value="6">{{ 6 | ConstructionTypeDesc }}</Option>
							<Option :value="7">{{ 7 | ConstructionTypeDesc }}</Option>
							<Option :value="8">{{ 8 | ConstructionTypeDesc }}</Option>
							<Option :value="9">{{ 9 | ConstructionTypeDesc }}</Option>
							<Option :value="10">{{ 10 | ConstructionTypeDesc }}</Option>
							<Option :value="11">{{ 11 | ConstructionTypeDesc }}</Option>
							<Option :value="255">{{ 255 | ConstructionTypeDesc }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkOwner')" prop="ParkOwner">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkOwner" :placeholder="$t('StationManagement.ParkOwner')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkManager')" prop="ParkManager">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkManager" :placeholder="$t('StationManagement.ParkManager')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.EquipmentOwnerId')" prop="EquipmentOwnerId">
						<Input :disabled="ifViewStation" v-model="StationForm.EquipmentOwnerId" :placeholder="$t('StationManagement.EquipmentOwnerId')"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkOpratorType')" prop="ParkOpratorType">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.ParkOpratorType')" v-model="StationForm.ParkOpratorType">
							<Option :value="1">{{ $t('StationManagement.OperatedBySelf') }}</Option>
							<Option :value="2">{{ $t('StationManagement.OperatedBehalf') }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.OccupyPrice')" prop="Construction">
						<Select :disabled="ifViewStation" :placeholder="$t('StationManagement.OccupyPrice')" v-model="StationForm.OccupyPrice">
							<Option :value="0">{{ $t('StationManagement.Free') }}</Option>
							<Option v-bind:key="item.Id" v-for="(item) in occupyPriceList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="16">
					<FormItem :label="$t('StationManagement.Remark')" prop="Remark">
						<Input :disabled="ifViewStation" v-model="StationForm.Remark" :placeholder="$t('StationManagement.Remark')"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.IsOpen')" prop="IsOpen">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.IsOpen"
							size="large">
							<span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkOpenAllDay')" prop="ParkOpenAllDay">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.ParkOpenAllDay"
							size="large">
						    <span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.IsScanCode')" prop="IsScanCode">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.IsScanCode"
							size="large">
						    <span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem :label="$t('StationManagement.ParkFree')" prop="ParkFree">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.ParkFree"
							size="large">
								<span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.SupportWalletPayment')" prop="SupportWalletPayment">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0'
							v-model="StationForm.SupportWalletPayment" size="large">
								<span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label="$t('StationManagement.SupportOrder')" prop="SupportOrder">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.SupportOrder"
							size="large">
								<span slot="open">{{ $t('Common.Yes') }}</span>
							<span slot="close">{{ $t('Common.No') }}</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="24">
					<FormItem :label="$t('StationManagement.PaymentMode')" prop="PaymentMode">
						
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod1" size="large">
							<span slot="open">{{ $t('StationManagement.OfflineCard') }}</span>
							<span slot="close">{{ $t('StationManagement.OfflineCard') }}</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod2" size="large"
							style="margin-left: 15%;">
							<span slot="open">{{ $t('StationManagement.OnlineCard') }}</span>
							<span slot="close">{{ $t('StationManagement.OnlineCard') }}</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod3" size="large"
							style="margin-left: 15%;">
							<span slot="open">{{ $t('StationManagement.Alipay') }}</span>
							<span slot="close">{{ $t('StationManagement.Alipay') }}</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod4" size="large"
							style="margin-left: 15%;">
							<span slot="open">{{ $t('StationManagement.WeChat') }}</span>
							<span slot="close">{{ $t('StationManagement.WeChat') }}</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

			</Form>
			<div v-if="modal.type=='addStation'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">{{ $t('Common.Reset') }}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{ $t('Common.Add') }}</Button>
			</div>
			<div v-if="modal.type=='updateStation'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">{{ $t('Common.Edit') }}</Button>
			</div>
			<div v-if="modal.type=='viewStation'" slot="footer">
			</div>
		</Modal>
		<Modal :z-index="zindex" :mask-closable="false" v-model="showMap" :title="modal.Title" @on-ok="closeMap(true)"
			@on-cancel="closeMap(false)" width="70%">
			<div class="map-input">
				<Input class="lnglat" v-model="mapLng" disabled :placeholder="$t('StationManagement.Longitude')" />
				<Input class="lnglat" v-model="mapLat" disabled :placeholder="$t('StationManagement.Latitude')" />
				<Input class="search" search :enter-button="$t('Common.Search')" v-model="inputCity" @on-search="searchCity"
					:placeholder="$t('Common.inputCity')" />
			</div>
			<div id="map" style="width: 100%;height: 500px;margin-top: 5px;">
			</div>
	
		</Modal>
	
		<Modal v-model="showMechant" :title="$t('StationManagement.AssignMerchant')" @on-ok="assignMerchant" :mask-closable="false">
			<Form label-position="right" :label-width="100" ref="StationMerchantForm" :model="StationMerchantForm">
				<FormItem :label="$t('StationManagement.CollectionMch')" prop="CollectionMch">
					<Select :placeholder="$t('StationManagement.CollectionMch')" v-model="StationMerchantForm.CollectionMch">
						<Option v-bind:key="0" :value="0">{{ $t('StationManagement.Unconfigured') }}</Option>
						<Option v-bind:key="item.Id" v-for="(item) in PayeeMerchant" :value="item.Id">{{item.Name}}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="showEvcs" :title="$t('StationManagement.EvcsOperatorArray')" @on-ok="assignEvcs" :mask-closable="false">
			<Form label-position="right" :label-width="110" ref="StationEvcsForm" :model="StationEvcsForm">
				<FormItem :label="$t('StationManagement.EvcsOperatorArray')" prop="EvcsOperators">
					<Select :placeholder="$t('StationManagement.EvcsOperatorArray')" multiple v-model="StationEvcsForm.EvcsOperatorArray">
						<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in EvcsOperators" :value="item.Id">{{item.Name}}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './StationManagementExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import MapObj from '@/js/TMap.js';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	import commonFuncs from '../../../js/commonFuncs.js';
	export default {
		data() {
			return {
				getStationInfoUrl: webapi.base_api_url + '/Archives/GetStationInfo',
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				occupyPriceList: [],
				zindex: 2000,
				loadingStatus: false,
				mapInst: null,
				mapLng: 0,
				mapLat: 0,
				//
				params: "", //
				
				tableHeight: "650",
				modal: {
					Title: "add Station",
					type: "addStation"
				},
				modalView: false,

				
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//Add image deletion cache, and the deletion will actually take effect when the save button is clicked
				PictureDelCache: [],
				//Delete cache of original image
				PictureUpCache: [],
				/****************/

				//map modal
				center: [114.198595, 22.633595],
				showMap: false,
				inputCity: this.$t('StationManagement.SZ'),
				//Field Display
				ifAddStation: true,
				
				ifup: false,
				
				ifViewStation: false,

				showMechant: false,
				showEvcs: false,

				EvcsOperators: [],
		
				StationForm: {
					
					StationTypeDesc: this.$t('Enum.StationType.Public') ,
					StationStatusDesc: this.$t('Enum.StationStatus.Normal') ,
					StationPicturesArray: [],
					ConstructionDesc: this.$t('Enum.ConstructionType.ParkingLot') ,
					ParkOpratorTypeDesc: this.$t('StationManagement.OperatedBySelf') ,
					EvcsOperatorArray: [],
					Creator: "",
					Modifier: "",

					EquipmentNum: 0,
					ConnectorNum: 0,

					Id: 0,
					StationCode: "",
					StationName: "",
					OperatorId: "",
					OperatorName: "",
					EquipmentOwnerId: "",
					CountryCode: "",
					AreaCode: "",
					Address: "",
					StationTel: "",
					ServiceTel: "",
					StationType: 1,
					StationProperty: 1,
					ChargeFronter: 0,
					StationStatus: 50,
					ParkNum: 0,
					Longitude: 0,
					Latitude: 0,
					SiteGuide: "",
					Construction: 9,
					StationPictures: "",
					MatchCar: "",
					ParkInfo: "",
					BusinessHours: "00:00-24:00",
					ElectricityFee: "",
					ServiceFee: "",
					ParkFee: "",
					PaymentMode: 34,
					SupportOrder: 0,
					QueryType: 8,
					Remark: "",
					ParkOwner: "",
					ParkManager: "",
					ParkOpenAllDay: 1,
					ParkFree: 0,
					ParkOpratorType: 1,
					IsOpen: 1,
					IsScanCode: 1,
					SupportWalletPayment: 1,
					DisparkDate: "",
					CollectionMch: 0,
					EvcsOperators: "",
					CreateBy: 0,
					CreateTime: "",
					ModifyBy: 0,
					ModifyTime: ""
				},
				StationMerchantForm: {},
				StationEvcsForm: {},
				// Validate Fields
				ruleInline: {
					StationName: [{
						required: true,
						message: this.$t('StationManagement.StationName'),
						trigger: 'blur'
					}],
					OperatorId: [{
						required: true,
						message: this.$t('StationManagement.OperatorId') ,
						trigger: 'blur',
					}],
					StationTel: [{
						required: true,
						message: this.$t('StationManagement.StationTel') ,
						trigger: 'blur'
					}],
					ServiceTel: [{
						required: true,
						message: this.$t('StationManagement.ServiceTel') ,
						trigger: 'blur'
					}],
					StationType: [{
						required: true,
						message: this.$t('StationManagement.StationType') ,
						trigger: 'change',
						type: 'number'
					}],
					StationProperty: [{
						required: true,
						message: this.$t('StationManagement.StationProperty') ,
						trigger: 'change',
						type: 'number'
					}],
					ChargeFronter: [{
						required: true,
						message: this.$t('StationManagement.ChargeFronter') ,
						trigger: 'charge',
						type: 'number',
						min: 1,
					}],
					OperatorName: [{
						required: true,
						message: this.$t('StationManagement.OperatorName') ,
						trigger: 'change',
					}],
					AreaCode: [{
						required: true,
						message: this.$t('StationManagement.AreaCode'),
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: this.$t('StationManagement.AddrDetail') ,
						trigger: 'blur'
					}],
					Longitude: [{
						required: true,
						message: this.$t('StationManagement.Longitude') ,
						trigger: 'blur',
						type: 'number',
					}],
					Latitude: [{
						required: true,
						message: this.$t('StationManagement.Latitude'),
						trigger: 'blur',
						type: 'number'
					}],
					BusinessHours: [{
						required: true,
						message: this.$t('StationManagement.BusinessHours') ,
						trigger: 'blur'
					}]
				},
				BreadcrumbList: [ this.$t('Top.stationManage') , '>>',this.$t('stationManage') ],
				formInline: {
					StationId: 0,
					StationName: ''
				},
				operateColumnWidth: 30,

				//Table Title Data
				columns1: [{
						title: this.$t('StationManagement.StationName'),
						key: 'StationName',
						minWidth: 150
					}, {
						title: this.$t('StationManagement.AddrDetail'),
						key: 'Address',
						minWidth: 200
					},
					{
						title: this.$t('StationManagement.EquipmentQuantity'),
						key: 'EquipmentNum',
						minWidth: 150
					},
					{
						title: this.$t('StationManagement.ConnectorQuantity'),
						key: 'ConnectorNum',
						minWidth: 100
					},
					
					{
						title: this.$t('StationManagement.OnlineTime'),
						key: 'DisparkDate',
						minWidth: 200
					},
					{
						title: this.$t('StationManagement.StationType'),
						key: 'StationType',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								this.$options.filters.StationTypeDesc(params.row.StationType)
							);
						}
					},
					{
						title: this.$t('StationManagement.StationStatus'),
						key: 'StationStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								this.$options.filters.StationStatusDesc(params.row.StationStatus)
							);
						}
					},
					{
						title: this.$t('StationManagement.ServicePhone'),
						key: 'ServiceTel',
						minWidth: 140
					},
					{
						title: this.$t('StationManagement.BusinessHours'),
						key: 'BusinessHours',
						minWidth: 150
					},
					{
						title: this.$t('Common.Operator'),
						key: 'OperatorName',
						minWidth: 200
					}, {
						title: this.$t('Common.Actions'),
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px',
									},
									on: {
										click: () => {
											this.show("updateStation", params.row.Id)
										}
									}
								}, this.$t('Common.Edit')) : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//To avoid incorrect operations, confirm and cancel should function oppositely.
										click: () => {
											this.show("viewStation", params.row.Id)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, this.$t('Common.View')) : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
									'Dropdown', {
										on: {
											//To avoid incorrect operations, confirm and cancel should function oppositely.
											'on-click': (name) => {
												if (name == this.$t('StationManagement.AssignMerchant')) {
													this.StationMerchantForm.Id = params.row.Id;
													this.StationMerchantForm.CollectionMch = params.row
														.CollectionMch;
													this.showMechant = true;
													this.$nextTick(() => {
														this.StationMerchantForm.Id = params
															.row.Id;
														this.StationMerchantForm
															.CollectionMch = params.row
															.CollectionMch;
													})
													return;
												} else if (name ==this.$t('StationManagement.AssignEvcsOperator')) {
													this.StationEvcsForm.Id =
														params.row.Id;
													this.StationEvcsForm
														.EvcsOperatorArray = params
														.row.EvcsOperatorArray;
													this.StationEvcsForm
														.EvcsOperators = params.row
														.EvcsOperators;
													this.showEvcs = true;
													return;
												}
												this.$Modal.confirm({
													title: name,
													okText: this.$t('Common.Cancel'),
													cancelText: this.$t('Common.Confirm'),
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$t('Common.OtherActions')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name))
											.map((
												item) => { 
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				methodList: [{
						id: 0,
						name: 'assignMerchant',
						Status: this.$t('StationManagement.AssignMerchant')
					}, {
						id: 0,
						name: 'assignEvcs',
						Status: this.$t('StationManagement.AssignEvcsOperator')
					},
					{
						id: 1,
						name: 'building',
						Status: this.$options.filters.StationStatusDesc(1) 
					}, {
						id: 5,
						name: 'swithcOff',
						Status: this.$options.filters.StationStatusDesc(5) 
					},
					{
						id: 6,
						name: 'maintaining',
						Status: this.$options.filters.StationStatusDesc(6) 
					},
					{
						id: 50,
						name: 'running',
						Status: this.$options.filters.StationStatusDesc(50) ,
					}
				],
				data1: [],

				payValue: 0,
				widgets: [],
			};
		},
		async created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight);
			// this.widgets = this.$route.meta.widgets;// await commonFuncs.getWidgetByMenuId(this.$route.meta.menuId);
			// this.widgets.push({Name: 'edit'});
			// this.widgets.push({Name: 'view'});
			// this.widgets.push({Name: 'running'});
			// console.log('widgets', this.widgets);
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			//this.columns1.at(-1).minWidth = this.operateColumnWidth;
			
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
			this.GetChargeFronterList();
			this.getEvcsOperatorList();
			this.getOccupyPriceList();
			this.getStationParkingList();
			// console.log("useRoute", , this.$router.currentRoute, this.$route, this.$router);
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					StationName: _this.formInline.StationName,
				}
				return param
			},
			PayMethod1: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
					}
				}
			},
			PayMethod2: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
					}
				}
			},
			PayMethod3: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(1, 2))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
					}
				}
			},
			PayMethod4: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(0, 1))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
					}
				}
			},

			
			...mapState({
				StationList: 'Stations',
				OperatortypeList: 'typeList',
				ChargeFronterList: 'chargeFronterList',
				PayeeMerchant: 'PayeeMerchant',
				StationParkingList: 'StationParkingList',
			})
		},
		methods: {
			...mapActions([
				'GetUserStations',
				'GetChargeFronterList',
				'getStationParkingList'
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			
			show: function(type, params) {
				switch (type) {
					case "addStation":
						this.modal.type = "addStation";
						this.modal.Title =  this.$t('StationManagement.StationAdd');
						this.ifup = false
						this.ifViewStation = false
						this.modalCancel();
						break;
					case "updateStation":
						this.modal.type = "updateStation";
						this.modal.Title =  this.$t('StationManagement.StationEdit');
						this.ifup = true
						this.getUpdateMessage(params);
						this.ifViewStation = false
						break;
					case "viewStation":
						this.modal.type = "viewStation";
						this.modal.Title =  this.$t('StationManagement.StationView');
						this.getUpdateMessage(params);
						this.ifup = true
						this.ifViewStation = true
						break;
				}
				this.modalView = true;

			},
			//modal cancel operate
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("cancel or update，delete img")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			//Except for delete and modify operations
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.SetStationStatus, {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(name +  this.$t('Common.Success'));
						this.handleSubmit()
					}
				})
			},
			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.success(this.$t('Common.Success'));
					}
				})
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				this.uploadList = []
				this.$nextTick(() => {
					this.$refs.StationForm.resetFields();
					this.$refs.upload.clearFiles();
					this.defaultList = this.$refs.upload.fileList
				})
			},
			getUpdateMessage: function(Id) {
				console.log(Id);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].Id == Id) {
						_this.StationForm = Object.assign({}, _this.data1[i])
						let picList = [];
						let arr = _this.data1[i].StationPicturesArray
						for (let i = 0; i < arr.length; i++) {
							let url = ''
							// if (process.env.NODE_ENV === "development") {
							// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
							// }else {
							//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
							// }
							url = webapi.base_api_url + arr[i];
							let picture = {
								name: arr[i],
								url: url
							}
							picList.push(picture)
						}
						_this.defaultList = picList
						_this.$nextTick(() => {
							
							_this.uploadList = _this.$refs.upload.fileList
						})
					}
				}
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.Id = 0
						break;
					case "up":
						let picsArr = _this.PictureUpCache
						if (picsArr.length > 0) {
							let StationPictures = ''
							for (let i = 0; i < picsArr.length; i++) {
								if (i == (picsArr.length - 1)) {
									StationPictures += picsArr[i]
								} else {
									StationPictures += picsArr[i] + ','
								}
							}
							_this.deletePicture(StationPictures)
						}
						break;
				}
				_this.PictureDelCache = [];
				_this.PictureUpCache = [];
				let picsArr = _this.StationForm.StationPicturesArray
				_this.StationForm.StationPictures = ''
				for (let i = 0; i < picsArr.length; i++) {
					if (i == (picsArr.length - 1)) {
						_this.StationForm.StationPictures += picsArr[i]
					} else {
						_this.StationForm.StationPictures += picsArr[i] + ','
					}
				}
				const param = _this.StationForm
				this.$refs.StationForm.validate((valid) => {
					console.log("station " + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddStation',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								this.$Message.success(this.$t('Station') + type + this.$t('Common.Success'));
								this.$refs.sonPage.getList();
								this.modalView = false;
								this.GetUserStations()
							} else {
								this.$Message.error(this.$t('Station') + type + this.$t('Common.Failed'));
							}
						})
					}
				})
			},

			//map modal
			mapOpen: function() {
				const _this = this;
				this.showMap = true;
				let latlng = [this.StationForm.Longitude, this.StationForm.Latitude];
				if (!this.StationForm.Longitude || !this.StationForm.Latitude) latlng = this.center;
				this.mapLng = this.StationForm.Longitude;
				this.mapLat = this.StationForm.Latitude;

				this.$nextTick(() => {
					// gaodeMap.initMap("map", 9, this.center, 'normal');
					// gaodeMap.mapOn2(this);
					// gaodeMap.createMarke(latlng)
					// if (this.StationForm.Latitude != 0) {
					// 	gaodeMap.map.setCenter(latlng)
					// }
					_this.mapInst = new MapObj(window.TMap);
					_this.mapInst.initMap('map', 10, latlng[0], latlng[1]);
					const markerId = 1;
					_this.mapInst.createMarker(markerId, latlng[0], latlng[1]);
					_this.mapInst.on('click', (evt) => {
						_this.mapInst.setMarkerPosition(markerId, evt.latLng.lng, evt.latLng.lat);
						this.mapLng = evt.latLng.lng;
						this.mapLat = evt.latLng.lat;
					})
				})
			},
			closeMap: function(result) {
				const _this = this;
				if (result) {
					this.StationForm.Longitude = this.mapLng;
					this.StationForm.Latitude = this.mapLat;
				}
				// gaodeMap.map.destroy();
				// gaodeMap.map = '';
				_this.mapInst.destroyMap();
				this.showMap = false;
			},
			searchCity: function() {
				const _this = this
				// _this.$axios.get('https://apis.map.qq.com/ws/geocoder/v1/?address=%E6%B7%B1%E5%9C%B3%E5%8C%97%E7%AB%99&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77')
				this.mapInst.geoCoder(_this.inputCity).then(res => {
					_this.StationForm.Longitude = res.result.location.lng;
					_this.StationForm.Latitude = res.result.location.lat;
					_this.mapInst.setCenter(_this.StationForm.Longitude, _this.StationForm.Latitude);
					_this.mapInst.setMarkerPosition(1, _this.StationForm.Longitude, _this.StationForm.Latitude);
				});
				// gaodeMap.geoCode(_this.inputCity).then(res => {
				// 	_this.StationForm.Latitude = res.getLat()
				// 	_this.StationForm.Longitude = res.getLng()
				// 	gaodeMap.mapOn2(_this)
				// 	gaodeMap.createMarke(res)
				// 	gaodeMap.map.setCenter(res)
				// 	//console.log(res)
				// })
			},
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.success(this.$t('StationManagement.ImgDeleteSuccess'));
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.error(this.$t('StationManagement.ImgDeleteFail'));
						_this.handleSubmit()
					}
				})
			},
			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					console.log(fileList)
					console.log(_this.$refs.upload.fileList)
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationForm.StationPicturesArray = _this.StationForm.StationPicturesArray.filter(function(item,
					index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }else {
					//   file.url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationForm.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				let Operatortype = this.OperatortypeList.filter(function(item, index, arr) {
					return item.Name == a
				})
				this.StationForm.OperatorId = Operatortype[0].Id;
			},
			getEvcsOperatorList: function() {
				this.$axios.post(webapi.base_api_url + '/Common/GetEvcsOperatorList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.EvcsOperators = res.data.Data.List;
					}
				})
			},
			assignMerchant: function() {
				const _this = this;
				console.log(this.StationMerchantForm);
				let param = {
					StationId: this.StationMerchantForm.Id,
					MerchantId: this.StationMerchantForm.CollectionMch,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignMerchant', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.success(this.$t('StationManagement.AssignSuccess'));
					} else {
						_this.$Message.error(this.$t('StationManagement.AssignFail'));
					}
				});
			},
			assignEvcs: function() {
				const _this = this;
				console.log(this.StationEvcsForm);
				let param = {
					StationId: this.StationEvcsForm.Id,
					EvcsOperatorIds: this.StationEvcsForm.EvcsOperatorArray,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignEvcs', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.success(this.$t('StationManagement.AssignSuccess'));
					} else {
						_this.$Message.error(this.$t('StationManagement.AssignFail'));
					}
				});
			},
			getOccupyPriceList: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Common/GetSelctListByType', {
					Type: 9
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.occupyPriceList = res.data.Data.List;
					}
				});
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 16px;
	}

	.ivu-form-item-error-tip {
		padding-top: 0;
	}

	/* 	.ivu-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
 */
	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.map-input {
		display: flex;
		flex-direction: row;
	}

	.map-input .lnglat {
		width: 90px;
	}

	.map-input .search {
		flex: 1;
	}
</style>